import { type Locale, fmt, getDict } from '../i18n'

export function formatDuration(seconds: number, locale: Locale): string {
  const totalMinutes = Math.floor(Math.max(0, seconds) / 60)
  const h = Math.floor(totalMinutes / 60)
  const m = totalMinutes % 60
  const u = getDict(locale).duration
  if (h === 0) return fmt(u.minutes, { m })
  return fmt(m === 0 ? u.hours : u.hoursMinutes, { h, m })
}

/** 残りミリ秒を MM:SS にする。秒は切り上げ */
export function formatClock(ms: number): string {
  const total = Math.ceil(Math.max(0, ms) / 1000)
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}
